/*@flow*/
import { combineReducers } from 'redux';
import search from './reducers/search';
import results from './reducers/results';
import facets from './reducers/facets';
import ui from './reducers/ui';
import translations from './reducers/translations';
import permissions from './reducers/permissions';
import organizations from './reducers/organizations';

export default combineReducers({
  search,
  results,
  facets,
  ui,
  translations,
  permissions,
  organizations
});



// WEBPACK FOOTER //
// ./src/reducer.js